import { useStaticQuery, graphql } from "gatsby"

export const useHomeFinancingQuery = () => {
    const { wpPage } = useStaticQuery(
        graphql`
        query HomeFinancingQuery {
            wpPage(title: {eq: "Home"}) {
              financing {
                financingBackgroundImageMobile {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                financingBackgroundImageDesktop {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                financingForegroundImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                financingForegroundImageAltText
                financingContent
                phoneNumber
                phoneIcon {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
          }          
        `)
return wpPage.financing
}